module.exports = __webpack_public_path__ + "img/mute.c4e3d173.png";